import React, { useContext, useState } from 'react'
import { Grid, GridCell, ListMenu, ListMenuButton,
   TabMenu, TabMenuButton, Text, View } from 'oio-react'
import { Link } from 'react-router-dom'
import { SearchIcon } from 'assets/icons'
import SearchListItemRow from 'src/apps/Search/components/ListItemRow'
import Footer from 'src/components/Footer'
import GNS3Search from 'src/custom/gns3/Search'
import { useSearchInitiatives, useOrganization } from 'src/graphql/hooks'
import ThemeContext from 'src/libraries/contexts/Theme'

const Search = () => {
   const [activeSearchValue, setActiveSearchValue] = useState('')
   const [selectedInitiativeTypeId, setSelectedInitiativeTypeId] = useState(null)
   const theme = useContext(ThemeContext)

   const { organization } = useOrganization()

   // TODO: This is temporary
   // See PR #359
   if (organization.slug === 'gns3') {
      return <GNS3Search />
   }

   const enabledInitiativeTypes = organization.initiativeTypes.filter(t => t.enabled)
   const currentInitiativeType = enabledInitiativeTypes.find(i => i.id === selectedInitiativeTypeId)
   const initiativeTypeFilterButtons = enabledInitiativeTypes.map(type => ({
      id: type.id,
      name: type.namePlural
   }))

   const { searchInitiatives: searchResults, loading } = useSearchInitiatives({
      initiativeTypeIds: selectedInitiativeTypeId,
      search: activeSearchValue
   }, {
      // TODO: Skip is currently not respected
      // See: https://github.com/apollographql/apollo-client/issues/6190
      skip: activeSearchValue === ''
   })

   const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
         event.preventDefault()
         setActiveSearchValue(event.currentTarget.value.trim())
      }
   }

   return (
      <View width="100%">
         <View
            borderTop="1px solid #e5e5e5"
            marginTop={theme.viewportMarginTop}
            paddingLeft={theme.viewportMarginLeft}
            paddingRight={theme.viewportMarginRight}
            width="100%"
            minHeight="100vh">
            <View
               display="flex"
               justifyContent="center"
               width="100%">
               <View
                  width="100%"
                  maxWidth={theme.viewportContentMaxWidth}
                  paddingRight={theme.viewportPaddingRight}
                  paddingLeft={theme.viewportPaddingLeft}>
                  <View
                     width="100%"
                     display="flex"
                     alignItems="center">
                     <View width="100%">
                        <View width="100%">
                           <View
                              display="flex"
                              alignItems="center"
                              width="100%"
                              height="50px[a-b] 70px[c-f]"
                              padding="0px 20px[a-b] 0px 30px[c-f]"
                              margin="30px 0px 0px 0px[a-c] 40px 0px[d-f]"
                              backgroundColor="#eee"
                              borderRadius="3px">
                              <View
                                 display="flex"
                                 alignItems="center"
                                 flex="0 0 auto"
                                 width="16px[a-b] 20px[c-f]"
                                 height="16px[a-b] 20px[c-f]"
                                 marginRight="20px">
                                 <SearchIcon width="100%" height="100%" color="#aaa" />
                              </View>
                              <View
                                 display="flex"
                                 alignItems="center"
                                 flex="1 1 auto"
                                 height="70px">
                                 <input
                                    id="searchInput"
                                    onKeyPress={handleKeyPress}
                                    type="text"
                                    placeholder="Search"
                                    style={{
                                       fontSize: '22px',
                                       width: '100%',
                                       height: '100%',
                                       backgroundColor: 'transparent'
                                    }}
                                 />
                              </View>
                           </View>
                        </View>
                        <View
                           float="left"
                           width="100%[a-c] 250px[d-f]"
                           paddingRight="40px[d-f]">
                           <View
                              display="block[a-c] none[d-f]"
                              float="left"
                              width="100%"
                              marginBottom="30px"
                              borderBottom="1px solid #eee">
                              <TabMenu>
                                 <TabMenuButton
                                    onClick={() => setSelectedInitiativeTypeId(null)}
                                    name="All"
                                    isActive={selectedInitiativeTypeId === null}
                                 />
                                 {initiativeTypeFilterButtons.map(button => (
                                    <TabMenuButton
                                       key={button.id}
                                       onClick={() => setSelectedInitiativeTypeId(button.id)}
                                       name={button.name}
                                       isActive={selectedInitiativeTypeId === button.id}
                                    />
                                 ))}
                              </TabMenu>
                           </View>
                           <View display="none[a-c] block[d-f]" float="left" width="100%">
                              <ListMenu
                                 buttonBorderRadius="2px"
                                 buttonPaddingHorizontal="15px"
                                 buttonTextSize="2.5"
                                 buttonSize="lg"
                                 dividerLineStyle="none">
                                 <ListMenuButton
                                    onClick={() => setSelectedInitiativeTypeId(null)}
                                    name="All"
                                    isActive={selectedInitiativeTypeId === null}
                                 />
                                 {initiativeTypeFilterButtons.map(button => (
                                    <ListMenuButton
                                       key={button.id}
                                       onClick={() => setSelectedInitiativeTypeId(button.id)}
                                       name={button.name}
                                       isActive={selectedInitiativeTypeId === button.id}
                                    />
                                 ))}
                              </ListMenu>
                           </View>
                        </View>
                        <View
                           float="left"
                           width="100%[a-c] calc(100% - 250px)[d-f]"
                           paddingTop="40px[d-f]"
                           paddingLeft="40px[d-f]"
                           paddingBottom="100px"
                           minHeight="70vh[c-f]"
                           borderRadius="3px"
                           backgroundColor="#fff"
                           border="1px solid #e5e5e5[d-f]">
                           {!activeSearchValue && (
                              <View width="100%" padding="30px" textAlign="center">
                                 <Text size="3" color="#888">
                                    Enter a search term to begin
                                 </Text>
                              </View>
                           )}
                           {loading && (
                              <View width="100%" padding="30px" textAlign="center">
                                 <Text
                                    size="3"
                                    color="#333"
                                    weight="medium"
                                    style={{
                                       display: 'inline-block'
                                    }}>
                                       Searching...
                                 </Text>
                              </View>
                           )}
                           {!loading && activeSearchValue && searchResults.items.length === 0 && (
                              <View width="100%" padding="30px" textAlign="center">
                                 <Text size="3" color="#888">
                                    {selectedInitiativeTypeId === null
                                       ? 'There were no results found for '
                                       : `There are no ${currentInitiativeType.namePlural} results for `
                                    }
                                    <Text
                                       size="3"
                                       color="#333"
                                       weight="medium"
                                       style={{
                                          display: 'inline-block'
                                       }}>
                                       {activeSearchValue}
                                    </Text>
                                 </Text>
                              </View>
                           )}
                           {activeSearchValue && searchResults.items.length > 0 && (
                              <View>
                                 <View paddingBottom="30px">
                                    <Text size="2.5[a-b] 3[c-f]" color="#888">
                                       {`Showing ${searchResults.items.length} results for `}
                                       <Text
                                          size="2.5[a-b] 3[c-f]"
                                          color="#333"
                                          weight="medium"
                                          style={{
                                             display: 'inline-block'
                                          }}>
                                          {activeSearchValue}
                                       </Text>
                                    </Text>
                                 </View>
                                 <View maxWidth="800px[d-f]">
                                    <Grid columns="1" spacing="0px">
                                       {/* eslint-disable-next-line max-len */}
                                       {searchResults.items.map(({ matches, value: initiative }) => (
                                          <GridCell key={initiative.id}>
                                             <Link to={`/initiatives/${initiative.slug}`}>
                                                <SearchListItemRow
                                                   dateAdded={initiative.dateAdded}
                                                   matches={matches}
                                                   label={initiative.type.nameSingular}
                                                   numThreadMessages={initiative.thread.numEntries}
                                                   numViews={initiative.numViews}
                                                   summary={initiative.body.summary}
                                                   title={initiative.name}
                                                />
                                             </Link>
                                          </GridCell>
                                       ))}
                                    </Grid>
                                 </View>
                                 {/*
                                 {searchResults.listInfo.hasNext && (
                                    <View
                                       width="100%"
                                       display="flex"
                                       justifyContent="center"
                                       padding="12px 0px">
                                       <Button
                                          color="#eee"
                                          textColor="#333"
                                          size="sm"
                                          onClick={handleLoadMore}
                                          name="Load More"
                                          mode={loading ? 'loading' : 'normal'}
                                       />
                                    </View>
                                 )}
                                 */}
                              </View>
                           )}
                        </View>
                     </View>
                  </View>
               </View>
            </View>
         </View>
         <Footer textColor="#aaa" />
      </View>
   )
}

export default Search
